import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./navbar/Navbar";
import AllRoutes from "./router/Routes";
import "./styles.css";

const App = () => {
  return (
    <Router>
      <Navbar />
      <AllRoutes />
    </Router>
  );
};

export default App;
